<template>
  <div>
    <div>
      <div class="col-12 course_row" v-for="(course, index) in selectedProgram.courses" :key="course.originUuid">

      <div class="row">
        <div class="title" :class="(course.entityType === 'deliverycontext') ? 'col-6' : 'col-8'" :style="{cursor: (course.entityType === 'deliverycontext') ? 'pointer' : 'default'}" @click="openLearnerCourseReportModal(course)">
          <div class="thumbnail_sec">
            <div class="thumbnail" :style="{background: setThumbnailBgColor(course.uuid)}">
              <div v-html="setThumbnailTitle(course)"></div>
            </div>
            <template v-if="(course.entityType === 'catalog')">
              <div class="credit_info">
                {{course.creditsEarned}} credits
              </div>
            </template>
          </div>
          <div class="col_title">
            <div>{{course.title}}</div>
          </div>
        </div>
        <template v-if="(course.entityType === 'deliverycontext')">
          <div class="col-6 progress_bar">
            <div class="row">
              <div class="col-1 lnk_container" style="margin-top: 2px; padding-right: 0px;">
                <b-link class="btn_lock_unlock" @click="openReleaseDetailModal(course, false)" v-if="(!course.releaseStatus)">
                  <span class="ic22-lock"></span>
                </b-link>
                <b-link class="btn_lock_unlock" @click="openReleaseDetailModal(course, true)" v-if="(course.releaseStatus && course.releaseLogicDetail && course.releaseLogicDetail.length>1)">
                  <span class="ic22-unlock"></span>
                </b-link>
              </div>

              <div class="col-11 pl-0">
                <advisee-program-course-score-and-progress :course-id="course.originUuid" :user-id="uuid" @progressSummary="aggregateProgressSummary"></advisee-program-course-score-and-progress>
              </div>
            </div>
          </div>
        </template>
        <template v-if="(course.entityType === 'catalog')">
          <div class="col-4 progress_status" style="margin-bottom: 16px;">
            <div class="btn_container float-right">
              <b-button :class="courseStatusBackgroundMap[course.courseStatus]" style="cursor: default;">
                <div style="color: #fff;">{{courseStatusMap[course.courseStatus]}}</div>
              </b-button>
            </div>
          </div>
        </template>
      </div>
    </div>
    </div>

    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="learnerCourseReleaseModal" class="description_modal" size="md" id="course-report-popup" hide-footer >
        <div slot="modal-header" class="header-section">
          <div class="ic_container">
            <span class="ic ic22-lock" v-if="!releaseStatus"></span>
            <span class="ic ic22-unlock" v-else></span>
          </div>
          <div class="head_txt">{{releaseModalHeaderLabel}}</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeLearnerCourseReleaseModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-12 txt_row">
            <div v-html="selectedCourseForReleaseTitle"></div>
          </div>
          <div class="col-12 txt_row">
            <div v-html="releaseLogicDetail"></div>
          </div>
          <div class="col-12 txt_row" >
            <div v-if="!releaseStatus">
              <strong><i>Note: Once you unlock a course, it cannot be locked back.</i></strong>
            </div>
            <div v-else>
              Unlocked By <strong><i>{{releaseStatusUpdatedBy}}  {{millisToDate(releaseStatusUpdatedTime)}} </i></strong>
            </div>
          </div>
          <div class="col-12 txt_row">
            <div class="float-right mr-5" >
              <b-button @click="closeLearnerCourseReleaseModal">Ok</b-button>
            </div>
            <div class="float-right mr-5" v-if="!releaseStatus">
              <b-button @click="manualRelease">Unlock Course</b-button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal id="course-report-popup" class="full_screen_modal" ref="learnerCourseReportModal" :header-bg-variant="'academic-progress-popup-header'" size="" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt head_txt text-center" style="width: 80%;">
            <span style="padding-left: 18rem;">{{reportModalHeaderLabel}}</span>
          </div>
          <div class="float-right">
            <button class="btn_close" aria-label="close" @click="closeLearnerCourseReportModal">
              <span class="ic-close"></span>
            </button>
          </div>
          <div class="float-right mr-5" v-if="isInstructorAdvisor">
            <span style="cursor: pointer; color: #157099;" @click="navigateToClassCourseReport"><strong>Go to course report</strong></span>
          </div>
        </div>

        <student-my-report v-if="selectedCourseForReporting" :uuid="selectedCourseForReporting.originUuid" :entityId="selectedCourseForReporting.originUuid" :userId="uuid"></student-my-report>

      </b-modal>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { DateTime } from 'luxon'
  import { mapState, mapActions } from 'vuex'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import AdviseeNote from './AdviseeNote'
  import AdviseeChannel from './AdviseeChannel'
  import NoteActionMenu from './NoteActionMenu'
  import ChannelActionMenu from './ChannelActionMenu'
  import AdviseeProgramCourseScoreAndProgress from './AdviseeProgramCourseScoreAndProgress'
  import StudentMyReport from '../../course/components/StudentMyReport'
  import AdvisorProgramCourseStructure from './AdvisorProgramCourseStructure'

  export default {
    name: 'advisor-program-course-structure',
    props: ['selectedProgram', 'advisee'],
    components: {
      AdviseeNote,
      AdviseeChannel,
      NoteActionMenu,
      ChannelActionMenu,
      StudentMyReport,
      AdviseeProgramCourseScoreAndProgress,
      AdvisorProgramCourseStructure
    },
    data: () => {
      return {
        isDataLoaded: false,
        modalHeaderLabel: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        },
        reportModalHeaderLabel: '',
        selectedCourseForReporting: null,
        selectedCourseForRelease: null,
        releaseModalHeaderLabel:'',
        releaseLogicDetail : '',
        releaseStatus : true,
        releaseStatusUpdatedBy : 'System',
        releaseStatusUpdatedTime: undefined,
        selectedCourseForReleaseTitle : ''
      }
    },
    async beforeMount () {
    },
    mounted () {
    },
    methods: {
      ...mapActions([
        'loadAdviseeDetail',
        'loadPersonTags',
        'loadStreamWithStructure',
        'loadLearnerEnrollmentData',
        'loadFutureCalendarEventsForParticipant',
        'loadMicroCompetencyProgressForSelectedUser',
        'releaseCourse'
      ]),
      resetData (data) {
        data.score = 0
        data.courses = []
        data.performance = 0
        data.childrenCount = 0
        data.childrenCompleteCount = 0
        data.progressSummaryCount = 0
        data.isScoreNotAvailable = true
      },
      async populateStreamStructure (data, replace) {
        let stream = await this.loadStreamWithStructure({programCode: data.programCode, userId: this.uuid})
        let structure = stream.structure
        if (structure) {
          let children = JSON.parse(structure)

          if (children.length > 0) {
            let childStructure = children[0].structure
            if (childStructure) {
              let structure = JSON.parse(childStructure)
              data.courses = _.sortBy(structure, 'order')

              /*
              let courses = _.filter(data.courses, (child) => {
                return (child.entityType === 'deliverycontext')
              })*/

              let courses = this.getCoursesFromStructure(data.courses)
              _.forEach(courses, async (course, index) => {
                let courseId = course.originUuid
                let mcSummary = await this.loadMicroCompetencyProgressForSelectedUser({entityId: courseId, userId: this.uuid})
                data.childrenCount += mcSummary.childrenCount
                data.childrenCompleteCount += mcSummary.childrenCompleteCount
                if (index === (courses.length - 1)) {
                  if(!replace){
                    this.enrolledPrograms.push(data)
                  }
                }
              })
            }
          }
        }
      },
      getCoursesFromStructure(entities) {
        let courses = []

        entities.forEach((item, i) => {
           if (item.entityType === 'folder') {
             if (item.structure) {
               let structure = JSON.parse(item.structure)
               if (structure) {
                 let recursionEntities = _.sortBy(structure, 'order')
                 courses.push(this.getCoursesFromStructure(recursionEntities))
               }
             }
           } else if (item.entityType === 'deliverycontext') {
             courses.push(item)
           }

        })

        return courses
      },
      aggregateProgressSummary (progressSummary) {
        if ((progressSummary.status === 1) || (progressSummary.status === 2)) {
          this.selectedProgram.progressSummaryCount += 1
          this.selectedProgram.isScoreNotAvailable = false
          this.selectedProgram.performance += progressSummary.performance
        }
        setTimeout(() => {
          this.selectedProgram.score = (this.selectedProgram.performance / this.selectedProgram.progressSummaryCount).toFixed(2)
        }, 1000)
      },
      openAcademicProgressModal (doNotReset) {
        if (!doNotReset) {
          this.selectedProgram = null
          this.modalHeaderLabel = this.advisee.userName + '\'s Academic Progress for All Programs'
        }
        this.$refs.academicProgressModal.show()
      },
      showSelectedProgramProgress (data) {
        this.selectedProgram = data
        this.modalHeaderLabel = this.advisee.userName + '\'s Academic Progress for ' + data.programTitle
      },
      closeAcademicProgressModal () {
        this.$refs.academicProgressModal.hide()
      },
      statusClass (data) {
        if (data.score && !data.isScoreNotAvailable) {
          if (data.score >= 90) {
            return 'gradeA'
          } else if (data.score >= 80 && data.score < 90) {
            return 'gradeB'
          } else if (data.score >= 65 && data.score < 80) {
            return 'gradeC'
          } else if (data.score >= 40 && data.score < 65) {
            return 'gradeD'
          } else if (data.score < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        if ((course.title.indexOf('-') !== -1) && (course.title.indexOf('-') < 7)) {
          let splitted = course.title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return course.title.substring(0, 7)
      },
      millisToDate (millis) {
        if(millis){
          return 'on ' + DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
        }else{
            return ''
        }

      },

      manualRelease () {
          this.releaseCourse(this.selectedCourseForRelease.uuid)
          this.releaseModalHeaderLabel = ''
          this.selectedCourseForReleaseTitle = ''
          this.$refs.learnerCourseReleaseModal.hide()
          this.selectedCourseForRelease = null

          this.resetData(this.selectedProgram)
          this.populateStreamStructure(this.selectedProgram, true)
          this.releaseLogicDetail = ''
          this.releaseStatus = true
          this.releaseStatusUpdatedBy = 'System'
          this.releaseStatusUpdatedTime =undefined

          // update when course is released.
          this.openAcademicProgressModal(true)

      },
      openReleaseDetailModal (course, unlocked) {
        this.releaseModalHeaderLabel = course.releaseStatus?'Course is Unlocked':'Course is Locked'
        this.selectedCourseForReleaseTitle = course.title
        this.$refs.learnerCourseReleaseModal.show()
        this.selectedCourseForRelease = course
        this.releaseLogicDetail = course.releaseLogicDetail
        this.releaseStatusUpdatedBy = course.releaseStatusUpdatedBy
        this.releaseStatusUpdatedTime = course.releaseStatusUpdatedTime
        this.releaseStatus = unlocked
      },
      closeLearnerCourseReleaseModal () {
        this.releaseModalHeaderLabel = ''
        this.selectedCourseForReleaseTitle = ''
        this.$refs.learnerCourseReleaseModal.hide()
        this.selectedCourseForRelease = null
        this.releaseLogicDetail = ''
        this.releaseStatus = true
        this.releaseStatusUpdatedBy = 'System'
        this.releaseStatusUpdatedTime =undefined

        this.openAcademicProgressModal(true)
      },
      openLearnerCourseReportModal (course) {
        this.reportModalHeaderLabel = this.advisee.userName + '\'s View of Course Report'
        this.$refs.learnerCourseReportModal.show()
        this.selectedCourseForReporting = course
      },
      closeLearnerCourseReportModal () {
        this.reportModalHeaderLabel = ''
        this.selectedCourseForReporting = null
        this.$refs.learnerCourseReportModal.hide()
        this.openAcademicProgressModal(true)
      },
      navigateToClassCourseReport () {
        let uuid = this.selectedCourseForReporting.originUuid
        return this.$router.push({name: 'classReport', params: {uuid: uuid, competencyId: uuid, isShowLearnosityReport: false, isAdvisorViewingReport: true}})
      },
      navigateToAdviseeProfile () {
        return this.$router.push({name: 'learnerProfilePage', params: {uuid: this.uuid}})
      }
    },
    computed: {
      ...mapState({
        'enabledFeatures': state => state.institution.enabledFeatures,
        'userObj': state => state.user.userObj
      }),
      advisorDashboardFeature () {
        return this.enabledFeatures[PACKAGE.FEATURE_IDS.ADVISTOR_DASHBOARD_FEATURE_ID]
      },
      isProgramProgressEnabled () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showProgramProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      isShowProgramName () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showProgramNameWithLabel') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      majorLabel () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showProgramNameWithLabel' && flags[i].label.length > 0) {
              return flags[i].label
            }
          }
        }
        return 'Program'
      },
      isShowCareerInterest () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCareerInterestWithLabel') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      careerLabel () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCareerInterestWithLabel' && flags[i].label.length > 0) {
              return flags[i].label
            }
          }
        }
        return 'Career Interest'
      },
      redirectStreamToProgressView () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'redirectStreamToProgressView') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      isLearnerProfileEnabled () {
        let profileFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROFILE_FEATURE_ID]
        if (profileFeature && profileFeature.enabled) {
          let flags = profileFeature.flags
          let found = _.find(flags, (flag) => {
            return (flag.title === 'advisorCanAccessLearnerProfile')
          })
          return found ? found.enabled : false
        }
        return false
      }
    }
  }
</script>

<style>
  .popup_head_txt {
    color: #323232;
    font-weight: 800;
    font-size: 1.4rem;
    float: left;
    width: 98%;
  }

  .bg-academic-progress-popup-header {
    background: #eaf8ff !important;
  }

  .header-text {
    color: #fff;
    font-weight: 500;
    font-size: x-large;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/AdvisorProgramCourseStructure.vue